import { forwardRef, Ref, type SVGProps } from 'react';

const SvgPaymentAmex = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 24"
    ref={ref}
    {...props}
  >
    <rect width={35} height={24} fill="#1f72cd" rx={3} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M6.275 8.5 3 15.747h3.92l.486-1.156h1.111l.486 1.156h4.315v-.882l.385.882h2.232l.384-.9v.9h8.975l1.09-1.126 1.023 1.126 4.609.01-3.285-3.613L32.016 8.5h-4.538l-1.062 1.105-.99-1.105h-9.763l-.838 1.87-.858-1.87h-3.912v.852L9.62 8.5zm13.4 1.03h5.154l1.576 1.702 1.627-1.703h1.577l-2.395 2.614 2.395 2.583H27.96l-1.576-1.722-1.636 1.722h-5.073zm1.274 2.025v-.95h3.216l1.403 1.518-1.465 1.526h-3.154v-1.036h2.812v-1.058zM7.035 9.529h1.91l2.173 4.914V9.53h2.093l1.678 3.524 1.546-3.524h2.083v5.2H17.25l-.01-4.074-1.848 4.074H14.26L12.4 10.655v4.074H9.793L9.3 13.564h-2.67l-.494 1.164H4.738zm.049 2.957.88-2.077.879 2.077z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPaymentAmex);
export default ForwardRef;
